import { VmsService } from 'src/app/services/vms.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ExcelDataProvider } from 'src/app/providers/excel.provider';

@Component({
  standalone: false,
  selector: 'app-bulk-invite',
  templateUrl: './bulk-invite.component.html',
  styleUrls: ['./bulk-invite.component.scss'],
})
export class BulkInviteComponent implements OnInit {
  formData: FormData;
  uploadFile: any;
  fileName: any;
  success: boolean;
  constructor(
    private router: Router,
    private vmsSrv: VmsService,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((res) => {
      this.success = res?.sucess ? res?.sucess : false;
    });
  }

  handleFileSelect(evt) {
    var files = evt.target.files;
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json
      .parseExcel(files[0])
      .then((data) => {
        // this.prepareTableData(JSON.parse(data));
        this.vmsSrv.setExcelData(data);
        this.router.navigate(['/vms/bulk-invite/preview']);
      })
      .catch((err) => {
        console.log('Failed to read excel ', err);
      });
  }

  downloadFile() {
    this.vmsSrv.getTemplate().subscribe((res) => {
      console.log(res);
    });
  }
}
